module.exports = __webpack_public_path__ + "static/img/cr.3d66352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/cr.png
// module id = 4xEA
// module chunks = 18